import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Done: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Done',
  minWidth: 50,
  accessorFn: () => '',
});
